import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import loanDetailsEN from './locales/en/loanDetails.json';
import personalInformationEN from './locales/en/personalInformation.json';
import loanDetailsES from './locales/es/loanDetails.json';
import personalInformationES from './locales/es/personalInformation.json';
import enumEN from './locales/en/enum.json';
import enumES from './locales/es/enum.json';
import assetsEN from './locales/en/assets.json';
import assetsES from './locales/es/assets.json';
import declarationsEN from './locales/en/declarations.json';
import declarationsES from './locales/es/declarations.json';
import expensesEN from './locales/en/expenses.json';
import expensesES from './locales/es/expenses.json';
import liabilitiesEN from './locales/en/liabilities.json';
import liabilitiesES from './locales/es/liabilities.json';
import employmentAndIncomeEN from './locales/en/employmentAndIncome.json';
import employmentAndIncomeES from './locales/es/employmentAndIncome.json';
import sideMenuEN from './locales/en/sideMenu.json';
import sideMenuES from './locales/es/sideMenu.json';
import homeEN from './locales/en/home.json';
import homeES from './locales/es/home.json';
import saveGridEN from './locales/en/saveGrid.json';
import saveGridES from './locales/es/saveGrid.json';
import accordionTitleEN from './locales/en/accordionTitle.json';
import accordionTitleES from './locales/es/accordionTitle.json';
import popupTextsEN from './locales/en/popupTexts.json';
import popupTextsES from './locales/es/popupTexts.json';
import footerEN from './locales/en/footer.json';
import footerES from './locales/es/footer.json';
import infoTextEN from './locales/en/infoText.json';
import infoTextES from './locales/es/infoText.json';
import eConsentEN from './locales/en/eConsent.json';
import eConsentES from './locales/es/eConsent.json';
import consumerConsentEN from './locales/en/consumerConsent.json';
import consumerConsentES from './locales/es/consumerConsent.json';
import borrowerAuthorizationConsentEN from './locales/en/borrowerAuthorizationConsent.json';
import borrowerAuthorizationConsentES from './locales/es/borrowerAuthorizationConsent.json';

const resources = {
  en: {
    translations: { ...loanDetailsEN, ...personalInformationEN, ...assetsEN, ...expensesEN, ...liabilitiesEN, ...declarationsEN, ...employmentAndIncomeEN, ...enumEN, ...sideMenuEN, ...homeEN, ...saveGridEN, ...accordionTitleEN, ...popupTextsEN, ...footerEN, ...infoTextEN, ...eConsentEN, ...borrowerAuthorizationConsentEN, ...consumerConsentEN}
  },
  es: {
    translations:  { ...loanDetailsES, ...personalInformationES, ...assetsES, ...expensesES, ...liabilitiesES, ...declarationsES, ...employmentAndIncomeES, ...enumES, ...sideMenuES, ...homeES, ...saveGridES, ...accordionTitleES, ...popupTextsES, ...footerES, ...infoTextES, ...eConsentES, ...borrowerAuthorizationConsentES, ...consumerConsentES}
  }
};
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // we init with resources
    resources,
    fallbackLng: "en",
    debug: false,

    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",

    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false,
    },
    react: {
        // wait: true,
        useSuspense: true
    }
  });

export default i18n;
